<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="halftitlepage" id="bkht">
<h1 class="bkht">Looking for <i>The Stranger</i></h1>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Kaplan-Stranger-US-pbk-0002.vue?d7f0b2ac